import { FormManager } from '@bark/bark-core/src/components/legacy-scripts/form-manager';

export default function BrowserNotificationsSettings() {
    const formManager = FormManager();
    
    function Api() {

        var sellerNotificationOptions =  [
            {
                label: _t("seller_settings_browser-notifications:notification-options.new-leads"),
                id: "web_push_new_client",
                value: 0,
                active: false,
                hidden: false
            },
            {
                label: _t("seller_settings_browser-notifications:notification-options.customer-messages"),
                id: "web_push_new_message",
                value: 0,
                active: false,
                hidden: false
            },
            {
                label: _t("seller_settings_browser-notifications:notification-options.new-reviews"),
                id: "web_push_new_review",
                value: 0,
                active: false,
                hidden: false
            }
        ];
        var sendData = {
            'seller': {}
        };
        var instanceVars = {
            saveOneSignalIdToSellerProfile: function(userId){
                if(userId){
                    Bark.api('seller/notification/webpush',
                        {'onesignal_userid': userId},
                        function (data) {  },
                        function (err) { },
                        'POST'
                    )}
            },
            addListenerToCheckbox: function(optionRow) {
                var checkbox = $('#option-toggle-' + optionRow.id);
                checkbox.on('change', function () {
                    var checkbox = $(this);
                    var usertype = checkbox.data('usertype');
                    var id = $(this).prop('id').substr('option-toggle-'.length);
                    var value = $(this).prop('checked');
                    if (sendData[usertype].hasOwnProperty(id)) {
                        delete sendData[usertype][id];
                    } else {
                        sendData[usertype][id] = value ? 1 : 0;
                    }
                    formManager.dirty("browser-notifications", !$.isEmptyObject(sendData[usertype]));
                });
            },
            submitData: function(defer){
                if(sendData.seller){
                    Bark.api('seller/notification/',
                        sendData.seller,
                        function(data){
                            // modal logic will go here:
                            if($('input[type="checkbox"].switch:checked').length != 0){
                                browserPushManager.browserPushAvailableAsync(function(avail){
                                    if(avail){
                                        // skip all other checks and just show the prompt
                                        browserPushManager.createPermissionModal(true);
                                    }
                                    else{
                                        var template = $('#disabledmodal').text();
                                        window.modalManager.set(
                                            '',
                                            '',
                                            Handlebars.compile(template)({}),
                                            [
                                                '<div class="mx-auto">' + modalManager.basicOkayButtonHTML() + '</div>'
                                            ],
                                            'modal-sm'
                                        );
                                    }
                                });
                            }
                            sendData['seller'] = {};
                            formManager.dirty('browser-notifications', false);
                            defer.resolve();
                        },
                        function(err){
                            console.error(err.responseJSON,'error!');
                            formManager.showError();
                            defer.resolve();
                        },
                        'POST'
                    );
                }
            },
            cancelChanges: function(){
                Object.keys(sendData).forEach( function(usertype){
                    console.log(usertype);
                    Object.keys(sendData[usertype]).forEach(function(checkboxId){
                        var checkboxEl = $('#option-toggle-' + checkboxId);
                        console.log(checkboxEl);
                        checkboxEl.prop('checked', !sendData[usertype][checkboxId]);
                    });
                    sendData[usertype] = {};
                    formManager.dirty('browser-notifications', false);
                });
            },
            getNotificationOptions: function(callBack, startState, initiallyOff) {

                if (typeof startState === 'undefined') {
                    startState = false;
                }

                if (typeof initiallyOff === 'undefined') {
                    initiallyOff = false;
                }

                Bark.api(
                    'seller/self',
                    {},
                    function (data) {
                        var notifications = data.data.notifications;
                        var forDisplay = {options: []};
                        sellerNotificationOptions.map(function (currOpt, i, arr) {
                            var hidey = currOpt.hidden ? ' d-none ':'';
                            var bg = i % 2 === 0 ? ' bg-light ' : ' bg-white ';
                            let extras = hidey + bg;
                            forDisplay.options.push({
                                usertype: 'seller',
                                id: currOpt.id,
                                label: currOpt.label,
                                active: startState ? true : currOpt.active,
                                value: currOpt.id in notifications ?  notifications[currOpt.id]: 1,
                                hidden: currOpt.hidden,
                                extra_class:  extras,
                            });
                        });
                        callBack(forDisplay);
                    },
                    function (data) {
                        // @todo error handling This needs to hide waiting / display a message
                        console.error(data,'error from sellerself');
                    }
                );
            },
            notificationsAreSupported: function(){
                return true;
                // try {
                //     return OneSignal.isPushNotificationsSupported();
                // } catch {
                //     return false;
                // }
            },
            toggleWebNotificationsOptions: function(){
                let disabled = false;
                var pushyBoxen = $("[id^='option-toggle-push']");
                pushyBoxen.each(function(){
                    $(this).parent().parent().toggleClass('text-muted', disabled);
                    $(this).prop('disabled', disabled);
                });
            },
            populateWebNotificationOptions: function(template, target, formIsActive, initiallyOff) {

                if (typeof initiallyOff === 'undefined') {
                    initiallyOff = true;
                }

                api.getNotificationOptions(function (renderData) {
                    var render_template = Handlebars.compile(template);
                    $(target).html('');
                    $(target).html(render_template(renderData));
                    renderData.options.map(api.addListenerToCheckbox);
                }, formIsActive, initiallyOff);
            },
            showForm: function(enabled, startState, havePermission) {
                var t = this;
                var optionsList = $('.notifications-options-list')
                api.populateWebNotificationOptions(api.getTemplate(), optionsList, enabled && havePermission && startState === 'on', startState === 'off');
                api.toggleWebNotificationsOptions();
                api.updateSubtitle(havePermission, startState === 'on')
                formManager.register('browser-notifications', t.submitData, t.cancelChanges);
            },
            updateSubtitle: function(havePermission, isOn ){
                var subtitle = havePermission ?
                    ( isOn  ? _t("seller_settings_browser-notifications:notifications-on-text") : _t("seller_settings_browser-notifications:notifications-off-text") )
                    : _t("seller_settings_browser-notifications:notifications-no-permission-text")
                $('#push-notifications-subtitle').text(subtitle);
                $('#push-notifications-subtitle').addClass('alert alert-info text-center');

            },
            mainToggleHandlerListener: function(e){
                e.preventDefault();
                e.stopImmediatePropagation();
                var isOn = $(this).prop('checked');
                api.toggleWebNotificationsOptions();
                api.updateSubtitle(true,isOn);
                OneSignal.push(["setSubscription", isOn]);
            },
            mainTogglePermissionListener: function(e){
                e.preventDefault();
                e.stopImmediatePropagation();
                if($(this).prop('checked')){
                    $(this).prop('checked',false);
                }
                $('#seekpushpermission').modal();
            },
            requestPushPermissions: function(){
                $('.text-secondary.pb-3').text(_t("seller_settings_browser-notifications:permission-request-text"));
            },
            getTemplate: function() {
                return $('#option-list').text();
            },
            checkPushPermissionsAndShowForm: function(shortcircuit) {

                if (typeof shortcircuit === 'undefined') {
                    shortcircuit = false;
                }

                if (shortcircuit) {
                    // means we have gotten permission already, no need to check, which has a lag
                    api.showForm(true, 'on', true);
                } else {
                    OneSignal.push(function () {
                        OneSignal.push(["getNotificationPermission", function (permission) {
                            if (permission === 'granted') {
                                //If browser permission is granted, they may have previously muted
                                // so we' need to check if the start state is on or off
                                // but we definitely have permission.
                                OneSignal.isPushNotificationsEnabled(function (isEnabled) {
                                    if(isEnabled){
                                        api.showForm(true, isEnabled ? 'on' : 'off', true);
                                    }
                                    else{
                                        OneSignal.getUserId(function(userId) {
                                            api.showForm(true, userId && true ? 'on' : 'off', true);
                                        });
                                    }
                                });
                            } else {
                                // if 'default' or 'denied' we'll need ot request permission (which may not work)
                                // and so the form should be off either way
                                api.showForm(false, 'off', false);
                            }
                        }]);
                    });
                }
            },
            createPermissionModal: function(){
                var template = $('#modal-template').text();
                var modalContent = $('#permissionmodal').text();
                var modal_render = Handlebars.compile(template);

                $('#modal-container').html(
                    modal_render({
                        modal_id: 'seekpushpermission',
                        title: "",
                        content: modalContent,
                        action_buttons:[]
                    })
                );

                $('#permission-modal-allow').on('click',api.permissionModalSubmitHandler);
            },
            permissionModalSubmitHandler: function(){
                OneSignal.push(function() {
                    OneSignal.on('subscriptionChange', api.handleNewSubscription);
                    OneSignal.showNativePrompt();
                    $('#permission-modal-close').click();
                    // Occurs when the user's subscription changes to a new value.
                });
            },
            handleNewSubscription: function(isSubscribed) {
                if(isSubscribed){
                    OneSignal.off('subscriptionChange', api.handleNewSubscription);
                    OneSignal.push(function() {
                        OneSignal.getUserId(function (userId) {
                            api.saveOneSignalIdToSellerProfile(userId);
                            api.checkPushPermissionsAndShowForm(true);
                        });
                    });
                }
                else{
                    api.checkPushPermissionsAndShowForm();
                }
            }
        }
        Object.assign(this, instanceVars);
    };

    var api = new Api();
    // var isPushSupported =  api.notificationsAreSupported();
    // if(isPushSupported) {
    api.createPermissionModal();
    api.checkPushPermissionsAndShowForm(true);
    // }
    // handling notifications are not supported, not much for us to do:
    if(false){
        var optionsLists = $('.notifications-options-list');
        optionsLists.each(function(){
            var id = '' + $(this).prop('id');
            var render_template = Handlebars.compile(api.getTemplate());
            $('#' + id).html(render_template({}));
            $('#' + id).removeClass('waiting');
        });
    }
}
